
import React from 'react';
import { cn } from '@/lib/utils';

interface CodeEditorProps {
  value: string;
  onChange?: (value: string) => void;
  language?: string;
  height?: string;
  readOnly?: boolean;
}

export function CodeEditor({
  value,
  onChange,
  language = 'json',
  height = '300px',
  readOnly = false,
}: CodeEditorProps) {
  return (
    <div className={cn('border rounded-md overflow-hidden', { 'bg-muted': readOnly })}>
      <textarea
        value={value}
        onChange={onChange ? (e) => onChange(e.target.value) : undefined}
        className={cn(
          'w-full font-mono text-sm p-4 outline-none',
          'bg-background text-foreground',
          { 'bg-muted': readOnly }
        )}
        style={{ 
          height, 
          resize: 'vertical', 
          minHeight: '100px',
          tabSize: 2,
        }}
        spellCheck={false}
        readOnly={readOnly}
      />
    </div>
  );
}
